import React from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';

function Contact() {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className="px-3 px-md-5 bg-primary-pattern text-light contact-section" id="contact">
                {/* Contact Header */}
                <div className="row justify-content-center mb-5">
                    <div className="col-12 text-center">
                        <div className="contact-header">
                            <span className="contact-badge">
                                <i className="bi bi-chat-dots me-2"></i>
                                Get In Touch
                            </span>
                            <h2 className="text1 contact-title">Let's Connect & Create Impact</h2>
                            <p className="contact-subtitle">
                                Ready to join our mission of empowering African youth? We'd love to hear from you.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Contact Cards */}
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-10">
                        <div className="row g-4">
                            {/* Email Card */}
                            <div className="col-md-6">
                                <div className="contact-card">
                                    <div className="contact-icon">
                                        <i className="bi bi-envelope-fill"></i>
                                    </div>
                                    <div className="contact-info">
                                        <h5 className="contact-method">Email Us</h5>
                                        <a href="mailto:weflareglobal@gmail.com" className="contact-link">
                                            weflareglobal@gmail.com
                                        </a>
                                        <p className="contact-desc">Drop us a line anytime</p>
                                    </div>
                                </div>
                            </div>

                            {/* Phone Card */}
                            <div className="col-md-6">
                                <div className="contact-card">
                                    <div className="contact-icon">
                                        <i className="bi bi-telephone-fill"></i>
                                    </div>
                                    <div className="contact-info">
                                        <h5 className="contact-method">Call Us</h5>
                                        <a href="tel:254703912202" className="contact-link">
                                            +254 703 912 202
                                        </a>
                                        <a href="tel:254791623434" className="contact-link">
                                            +254 791 623 434
                                        </a>
                                        <p className="contact-desc">Available during business hours</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Social Media */}
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="social-section">
                            <h5 className="social-title text-center mb-4">Follow Our Journey</h5>
                            <div className="social-links">
                                <a href="https://www.linkedin.com/company/we-flare/" target="_blank" rel="noopener noreferrer" className="social-link">
                                    <i className="bi bi-linkedin"></i>
                                    <span>LinkedIn</span>
                                </a>
                                <a href="https://www.instagram.com/we_flare?igsh=NzRrY256cm81ZGFm" target="_blank" rel="noopener noreferrer" className="social-link">
                                    <i className="bi bi-instagram"></i>
                                    <span>Instagram</span>
                                </a>
                                <a href="https://web.facebook.com/profile.php?id=61556040766689" target="_blank" rel="noopener noreferrer" className="social-link">
                                    <i className="bi bi-facebook"></i>
                                    <span>Facebook</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="contact-footer">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6">
                            <p className="copyright-text text-center">
                                © {currentYear} WeFlare. All rights reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;
